/* eslint-disable react/prop-types,no-shadow */
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Button, Icon } from 'antd';
import { Panel } from 'components/ui/index';
import classNames from 'classnames/bind';
import DraggableFolder from '../Folders/DraggableFolder';
import styles from '../../emailTemplates.less';
import ActionButtonGroup from '../ActionButtonGroup';

const cx = classNames.bind(styles);

const EditFolder = ({
  editFolders: editFoldersReducer,
  deletedFolders: deletedFoldersReducer,
  setEditFolderViewVisible,
  moveCard,
  saveEditFolder: saveEditFolderAction,
}) => {
  const [editFolders, setEditFolders] = useState(editFoldersReducer);
  const [deletedFolders, setDeletedFolders] = useState(deletedFoldersReducer);

  useEffect(() => {
    setEditFolders(editFoldersReducer);
    setDeletedFolders(deletedFoldersReducer);
  }, [editFoldersReducer, deletedFoldersReducer]);

  const createNewFolder = () => {
    const newFolder = {
      name: '',
      id: Math.floor(Math.random() * 100) * -1, // NOTE: unique id (test out only negative number could be successfully written to database)
    };
    setEditFolders(prevState => [...prevState, newFolder]);
  };

  const deleteFolderHandler = folderId => {
    setEditFolders(prevState => prevState.filter(folder => folder.id !== folderId));
    setDeletedFolders(prevState => [...prevState, folderId]);
  };

  const updateFolderNameHandler = (folderId, folderName) => {
    setEditFolders(prevState => prevState.map(folder => {
      if (folder.id === folderId) return { ...folder, name: folderName };
      return folder;
    }));
  };

  const saveEditFolderHandler = () => {
    saveEditFolderAction(editFolders, deletedFolders);
  };

  const cancelHandler = () => {
    setEditFolders(editFoldersReducer);
    setDeletedFolders(deletedFoldersReducer);
    setEditFolderViewVisible(false);
  };

  const actionsRight = (
    <div>
      <Button
        className="btn-ellipse email-theme-btn"
        size="small"
        onClick={createNewFolder}
      >
        <Icon type="plus" />
        <FormattedMessage id="page.emailTemplates.newFolder" />
      </Button>
    </div>
  );

  return (
    <Panel
      panelTitle={<FormattedMessage id="page.emailTemplates.editFolderTitle" />}
      panelClasses="email-theme-panel"
      actionsRight={actionsRight}
    >
      <Row className={cx('folders')}>
        {editFolders.map((item, key) => (
          <Col
            key={key}
            className="pl-lg mb-md gutter-row field-label"
            span={6}
          >
            <DraggableFolder
              key={item.id}
              item={item}
              onDeleteFolder={deleteFolderHandler}
              onUpdateFolderName={updateFolderNameHandler}
              id={item.id}
              index={key}
              moveCard={moveCard}
            />
          </Col>
        ))}
      </Row>
      <ActionButtonGroup
        saveEditFolder={saveEditFolderHandler}
        cancel={cancelHandler}
      />
    </Panel>
  );
};

export default EditFolder;



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/editFolderComponent/index.js